"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * Removes properties with given keys from object
 * and returns a new object with the removed properties
 *
 * WARNING: mutates the passed in object!
 */
var pickAndRemoveFromObject = function pickAndRemoveFromObject(object, keys) {
  return keys.reduce(function (newObject, key) {
    if (typeof object[key] !== "undefined") {
      newObject[key] = object[key];
    }
    try {
      delete object[key];
    } catch (e) {}
    return newObject;
  }, {});
};
var _default = exports.default = pickAndRemoveFromObject;